<template>
  <v-container>
    <v-card class="pa-0">
      <v-card-title>
        File List
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        dense
        :headers="headers"
        :items="items.results"
        :server-items-length="items.totalResults"
        :options.sync="pagination"
        :footer-props="{'items-per-page-options':[30, 45, 60, -1]}"
        :loading="loading"
        item-key="file_id"
        class="elevation-1"
      >
        <template v-slot:item.file_name="{item}">
          <span ref="textToCopy" :id="'textToCopy_'+item.id">{{item.url}}</span>
        </template>
        <template v-slot:item.action="{item}">
          <v-btn color="grey darken-2" icon dark v-clipboard:copy="item.url" v-clipboard:success="onCopy">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="primary" fixed fab bottom right to="/file/add">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-container>
</template>
<script>
 
import { parseParams, getAlphabets } from "../../plugins/helper";
import { mapMutations } from "vuex";
export default {
  name: "Filelist",
  data() {
    return {
      loading: false,
      dialog: false,
      category: {},
      search: "",
      items: {
        current_page: 1,
        per_page: 10,
        data: [],
      },
      headers: [
        { text: "Title", value: "title" },
        { text: "File URL", value: "file_name" },
        { text: "Action", value: "action" },
      ],
      pagination: {
        itemsPerPage: 30,
        sortBy: ["created_at"],
        page: 1,
        filters: {
          item_active: true,
          alphabet: "",
        },
      },
      alphabets: getAlphabets(),
    };
  },
  computed: {
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "name";
      return paginationData;
    },
    getStyles() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {
          maxWidth: "95%",
          margin: "0 auto",
        };
      } else {
        return {};
      }
    },
  },
  watch: {
    search() {
      this.getItems();
    },
    pagination: {
      handler: function () {
        this.getItems();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    onCopy () {
      this.setAlert({
        show: true,
        variant: "default",
        message: 'File URL copied',
        dismissCountDown: 1000,
      });
    },
    getItems() {
      let _self = this;
      this.loading = "secondary";
      let url = parseParams(this.pageData);
      this.$axios.get("/admin/file/list?" + url)
        .then((response) => {
          _self.items = response.data.data;
          this.loading = false;
        })
        .catch(function () {
          this.loading = false;
        });
    },
  }
};
</script>